import { render } from "./DescriptionButton.vue?vue&type=template&id=6c2a2b2e&scoped=true"
import script from "./DescriptionButton.vue?vue&type=script&lang=js"
export * from "./DescriptionButton.vue?vue&type=script&lang=js"

import "./DescriptionButton.vue?vue&type=style&index=0&id=6c2a2b2e&lang=scss&scoped=true"
import "./DescriptionButton.vue?vue&type=style&index=1&id=6c2a2b2e&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c2a2b2e"]])

export default __exports__